<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup" *ngIf="model === 'undefined'">
  <div *ngIf="!hideLabel" class="label d-flex justify-content-between">
    <span>
      {{ 'EVENT_SELECT.EVENT' | translate }}
    </span>

    <span *ngIf="parentFormGroup.get('event_id').value">
      <button type="button" class="btn btn-ico btn-link" (click)="edit()">
        <i class="fal fa-pencil"></i>
      </button>
    </span>
  </div>

  <ng-container *ngIf="isInModal; else outsideModal">
  <ng-select
    [items]="data | async"
    bindLabel="name"
    bindValue="id"
    [loading]="loader"
    [formControlName]="'event_id'"
    [typeahead]="input$"
    (change)="onChange($event)"
    (scrollToEnd)="loadMore()"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="event-select-option-wrapper">
        <div class="event-name">{{ item.name }}</div>
        <div class="event-dates">
          {{ item.date_from | amDateFormat : env.momentDateFormat }}
          - {{ item.date_to | amDateFormat : env.momentDateFormat }}
        </div>
        <div class="event-venue-wrapper">
          <div class="event-venue-name" *ngIf="item.venue">{{ item.venue.name }} &#64;</div>
          <div class="event-venue-city" *ngIf="item.venue?.city">{{ item.venue.city.name }},</div>
          <div class="event-venue-country" *ngIf="item.venue?.city?.country">{{ item.venue.city.country.name }}</div>
        </div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'EVENT_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
  </ng-container>

  <ng-template #outsideModal>
  <ng-select
    [items]="data | async"
    bindLabel="name"
    bindValue="id"
    [loading]="loader"
    [formControlName]="'event_id'"
    appendTo="body"
    [typeahead]="input$"
    (change)="onChange($event)"
    (scrollToEnd)="loadMore()"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="event-select-option-wrapper">
        <div class="event-name">{{ item.name }}</div>
        <div class="event-dates">
          {{ item.date_from | amDateFormat : env.momentDateFormat }}
          - {{ item.date_to | amDateFormat : env.momentDateFormat }}
        </div>
        <div class="event-venue-wrapper">
          <div class="event-venue-name" *ngIf="item.venue">{{ item.venue.name }} &#64;</div>
          <div class="event-venue-city" *ngIf="item.venue?.city">{{ item.venue.city.name }},</div>
          <div class="event-venue-country" *ngIf="item.venue?.city?.country">{{ item.venue.city.country.name }}</div>
        </div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'EVENT_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
  </ng-template>
</div>

<div class="form-group" *ngIf="model !== 'undefined'">
  <label>{{ 'EVENT_SELECT.EVENT' | translate }}</label>

  <ng-container *ngIf="isInModal; else outsideModal">
  <ng-select
    [items]="data | async"
    bindLabel="name"
    [loading]="loader"
    [(ngModel)]="model"
    (change)="changeModel($event)"
    [typeahead]="input$"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="event-select-option-wrapper">
        <div class="event-name">{{ item.name }}</div>
        <div class="event-dates">
          {{ item.date_from | amDateFormat : env.momentDateFormat }}
          - {{ item.date_to | amDateFormat : env.momentDateFormat }}
        </div>
        <div class="event-venue-wrapper">
          <div class="event-venue-name" *ngIf="item.venue">{{ item.venue.name }} &#64;</div>
          <div class="event-venue-city" *ngIf="item.venue?.city">{{ item.venue.city.name }},</div>
          <div class="event-venue-country" *ngIf="item.venue?.city?.country">{{ item.venue.city.country.name }}</div>
        </div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'EVENT_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
  </ng-container>

  <ng-template #outsideModal>
  <ng-select
    [items]="data | async"
    bindLabel="name"
    [loading]="loader"
    [(ngModel)]="model"
    appendTo="body"
    (change)="changeModel($event)"
    [typeahead]="input$"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="event-select-option-wrapper">
        <div class="event-name">{{ item.name }}</div>
        <div class="event-dates">
          {{ item.date_from | amDateFormat : env.momentDateFormat }}
          - {{ item.date_to | amDateFormat : env.momentDateFormat }}
        </div>
        <div class="event-venue-wrapper">
          <div class="event-venue-name" *ngIf="item.venue">{{ item.venue.name }} &#64;</div>
          <div class="event-venue-city" *ngIf="item.venue?.city">{{ item.venue.city.name }},</div>
          <div class="event-venue-country" *ngIf="item.venue?.city?.country">{{ item.venue.city.country.name }}</div>
        </div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
        <button type="button" class="btn btn-primary btn-xs w-100" (click)="add(searchTerm)">
          <i class="fal fa-plus"></i> {{ 'EVENT_SELECT.ADD' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-select>
  </ng-template>


</div>
